// extracted by mini-css-extract-plugin
module.exports = {"panel":"style_panel__2P0Og","inner":"style_inner__2vWPj","recently":"style_recently__2eYyb","period":"style_period__1Qq2D","total":"style_total__2cDrw"};